module.exports = __webpack_public_path__ + "static/img/5.aef4759.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/5.png
// module id = 88yW
// module chunks = 0